import React, {useEffect} from "react";
import {useAuth} from "../../../context/AuthContext";

export default function Logout() {
	const {logout} = useAuth();
	useEffect(() => logout(true), []);

	return <div className="d-flex justify-content-center align-items">See you soon:-(</div>;
}
